import { Component, Input } from '@angular/core';
import { TwSolicitudFrSanidadExtViewModel } from '../inspecciones.types';
import { ComponentBase } from 'src/app/components/core/_infrastructure/classes/componentBase';
import { ExceptionManager } from 'src/app/components/core/_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from 'src/app/components/core/_infrastructure/classes/services/auth.service';
import { NotificationService } from 'src/app/components/core/_infrastructure/classes/services/notification.service';

@Component({
    selector: 'app-fr-sanidad-ext',
    templateUrl: './fr-sanidad-ext.component.html',
    styleUrls: ['./fr-sanidad-ext.component.scss'],
})
export class FrSanidadExtComponent extends ComponentBase {
    @Input() frSanidadExtInsp: TwSolicitudFrSanidadExtViewModel[];
    @Input() esRechazoParcial: boolean;

    colsFrecRedSanidadExt = [
        { field: 'Link', header: '' },
        { field: 'Id', header: 'Id', display: 'none' },
        { field: 'IdSolicitud', header: 'IdSolicitud', display: 'none' },
        { field: 'GrupoFrDescripcion', header: 'Grupo Higiene' },
        { field: 'CodigoTaric', header: 'Código TARIC' },
        { field: 'PaisOrigen', header: 'País Origen' },
        { field: 'PorcentajeFrecuenciaFisica', header: '% Física' },
        { field: 'PorcentajeFrecuenciaLab', header: '% Lab.' },
        { field: 'PorcentajePifFisica', header: '% PCF Física' },
        { field: 'PorcentajePifLab', header: '% PCF Laboratorio' },
        { field: 'PorcentajeNacionalFisica', header: '% Nacional Física' },
        { field: 'PorcentajeNacionalLab', header: '% Nacional Laboratorio' },
        { field: 'Riesgo', header: 'Riesgo' },
    ];

    constructor(
        protected authService: AuthService,
        protected notificacionService: NotificationService,
        protected exceptionHandler: ExceptionManager,
    ) {
        super(authService, notificacionService, exceptionHandler);
    }
}
